import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import assets from './assets';
import activity from './activity';
import userBalance from './userBalance';
import userFee from './userFee';
import charts from './charts';

const Analytics = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/exchangeAssetsReport`}/>
      <Route path={`${match.url}/exchangeAssetsReport`} component={assets}/>
      <Route path={`${match.url}/activityReport`} component={activity}/>
      <Route path={`${match.url}/usersBalanceReport`} component={userBalance}/>
      <Route path={`${match.url}/usersFeeReport`} component={userFee}/>
      <Route path={`${match.url}/charts`} component={charts}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Analytics;
